import { render, staticRenderFns } from "./ConfiguratorItem.vue?vue&type=template&id=5f2560b4&"
import script from "./ConfiguratorItem.vue?vue&type=script&lang=js&"
export * from "./ConfiguratorItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports